import classNames from "classnames";

interface Props {
  className?: string;
  children: React.ReactNode;
}

export const CustomCell: React.FC<Props> = ({ className, children }) => {
  const cn = classNames("flex box-border m-[16px] h-[22px]", className);
  return <div className={cn}>{children}</div>;
};
